module.exports = __webpack_public_path__ + "media/images/bonusForSharing__bg-23207bcb139f83e10a98c0bfdd700b77.jpg";